/* AUTO-GENERATED by twins/build_config.py — do not hand-edit. */
window.GBPPU_CONFIG = {
 "triggers": {
  "8403023855795": {
   "coll": "pistol-accessories",
   "type": "pistol"
  },
  "8403024314547": {
   "coll": "pistol-accessories",
   "type": "pistol"
  },
  "8403024445619": {
   "coll": "pistol-accessories",
   "type": "pistol"
  },
  "8403024511155": {
   "coll": "pistol-accessories-copy",
   "type": "pistol"
  },
  "8403024478387": {
   "coll": "bigblaster-accessories-copy",
   "type": "pistol"
  },
  "8403024347315": {
   "coll": "shell-longgun-accessories",
   "type": "rifle"
  },
  "8403024281779": {
   "coll": "pistol-accessories-copy-1",
   "type": "revolver"
  },
  "8416276906163": {
   "coll": "pistol-accessories",
   "type": "pistol"
  },
  "8403024412851": {
   "coll": "pistol-accessories",
   "type": "pistol"
  },
  "8403024117939": {
   "coll": "pistol-accessories",
   "type": "pistol"
  },
  "8403023593651": {
   "coll": "pistol-accessories-copy-3",
   "type": "rifle"
  },
  "8403024380083": {
   "coll": "pistol-accessories",
   "type": "pistol"
  },
  "8416277135539": {
   "coll": "pistol-accessories",
   "type": "pistol"
  },
  "8403023265971": {
   "coll": "pistol-accessories",
   "type": "pistol"
  },
  "8403023167667": {
   "coll": "venom-pro-accessories",
   "type": "revolver"
  },
  "8403022250163": {
   "coll": "pistol-accessories-copy-2",
   "type": "shotgun"
  },
  "8559512158387": {
   "coll": "outlaw-1873-add-ons",
   "type": "revolver",
   "offerKeys": [
    "extra-shells-darts-outlaw-1873",
    "western-thigh-holster",
    "sheriff-star-badge-outlaw-addon",
    "gun-holster",
    "safety-glasses",
    "targets",
    "schaumstoff-dartziele",
    "display-stand"
   ]
  },
  "8434689015987": {
   "coll": "shell-longgun-accessories",
   "type": "rifle"
  },
  "8403023823027": {
   "coll": "pistol-accessories",
   "type": "pistol"
  },
  "8451205169331": {
   "coll": "pulse-shellblaster-accessories-copy",
   "type": "pistol"
  },
  "8433004904627": {
   "coll": "shell-revolver",
   "type": "revolver"
  },
  "8434688753843": {
   "coll": "smg",
   "type": "SMG"
  },
  "8403023757491": {
   "coll": "pistol-accessories-copy-3",
   "type": "rifle"
  },
  "8403022381235": {
   "coll": "pistol-accessories-copy-3",
   "type": "rifle"
  },
  "8403024019635": {
   "coll": "pistol-accessories-copy-2",
   "type": "shotgun"
  },
  "8460521799859": {
   "coll": "pistol-accessories",
   "type": "pistol"
  },
  "8403023790259": {
   "coll": "pistol-accessories-copy-4",
   "type": "sniper"
  },
  "8403022741683": {
   "coll": "pistol-accessories-copy-4",
   "type": "sniper"
  },
  "8403023331507": {
   "coll": "inferno-accessories",
   "type": "minigun"
  },
  "8403023954099": {
   "coll": "pistol-accessories-copy-3",
   "type": "SMG"
  },
  "8479237439667": {
   "coll": "pistol-accessories-copy",
   "type": "pistol"
  },
  "8433004052659": {
   "coll": "shell-revolver",
   "type": "revolver"
  },
  "8403023691955": {
   "coll": "shell-longgun-accessories",
   "type": "SMG"
  },
  "8559475785907": {
   "coll": "longshot-barrett-add-ons",
   "type": "sniper"
  },
  "8559475425459": {
   "coll": "havoc-416-add-ons",
   "type": "rifle"
  },
  "8403022479539": {
   "coll": "pistol-accessories-copy-2",
   "type": "shotgun"
  },
  "8403022217395": {
   "coll": "water-accessories-drum",
   "type": "pistol"
  },
  "8480956743859": {
   "coll": "water-accessories-drum",
   "type": "SMG"
  },
  "8482696659123": {
   "coll": "pistol-accessories-copy-5",
   "type": "sniper"
  },
  "8482698952883": {
   "coll": "pistol-accessories-copy-5",
   "type": "SMG"
  },
  "8447884230835": {
   "coll": "water-accessories-drum",
   "type": "SMG"
  },
  "8487017545907": {
   "coll": "pistol-accessories-copy-5",
   "type": "SMG"
  },
  "8486278299827": {
   "coll": "water-accessories-drum",
   "type": "rifle"
  },
  "8484827660467": {
   "coll": "pistol-accessories-copy-5",
   "type": "soaker"
  },
  "8492071354547": {
   "coll": "pistol-accessories-copy-5",
   "type": "pistol"
  },
  "8487037894835": {
   "coll": "water-accessories-drum",
   "type": "SMG"
  },
  "8487021412531": {
   "coll": "pistol-accessories-copy-5",
   "type": "pistol"
  },
  "8447885377715": {
   "coll": "pistol-accessories-copy-5",
   "type": "pistol"
  },
  "8498974163123": {
   "coll": "pistol-accessories-copy-5",
   "type": "pistol"
  },
  "8494452474035": {
   "coll": "water-accessories-drum",
   "type": "pistol"
  },
  "8492069093555": {
   "coll": "pistol-accessories-copy-5",
   "type": "pistol"
  },
  "8486700515507": {
   "coll": "water-accessories-drum",
   "type": "SMG"
  },
  "8486682919091": {
   "coll": "pistol-accessories-copy-5",
   "type": "pistol"
  },
  "8486262800563": {
   "coll": "pistol-accessories-copy-5",
   "type": "pistol"
  },
  "8483682255027": {
   "coll": "water-accessories-drum",
   "type": "rifle"
  },
  "8483682222259": {
   "coll": "pistol-accessories-copy-5",
   "type": "rifle"
  },
  "8483682123955": {
   "coll": "water-accessories-drum",
   "type": "pistol"
  },
  "8483648569523": {
   "coll": "pistol-accessories-copy-5",
   "type": "rifle"
  },
  "8482666610867": {
   "coll": "water-accessories-drum",
   "type": "pistol"
  },
  "8502204661939": {
   "coll": "pistol-accessories-copy-5",
   "type": "pistol"
  },
  "8502210134195": {
   "coll": "water-accessories-drum",
   "type": "SMG"
  },
  "8502214525107": {
   "coll": "pistol-accessories-copy-5",
   "type": "pistol"
  },
  "8502216458419": {
   "coll": "water-accessories-drum",
   "type": "pistol"
  },
  "8503303340211": {
   "coll": "pistol-accessories-copy-5",
   "type": "rifle"
  },
  "8503449354419": {
   "coll": "pistol-accessories-copy-5",
   "type": "soaker"
  },
  "8512161382579": {
   "coll": "water-accessories-drum",
   "type": "rifle"
  },
  "8557065339059": {
   "coll": "cyclone-add-ons",
   "type": "revolver"
  },
  "8584135606451": {
   "coll": "outlaw-1873-add-ons",
   "type": "revolver",
   "offerKeys": [
    "gun-holster",
    "safety-glasses",
    "targets",
    "schaumstoff-dartziele",
    "display-stand"
   ]
  },
  "8609936212147": {
   "coll": "outlaw-1873-add-ons",
   "type": "revolver",
   "offerKeys": [
    "gun-holster",
    "safety-glasses",
    "targets",
    "schaumstoff-dartziele",
    "display-stand"
   ]
  },
  "8642048917683": {
   "coll": "raven-edu-addons",
   "type": "pistol",
   "offerKeys": [
    "raven-edu-addon-3in1-attachment-bundle",
    "raven-edu-addon-mega-dart-pack",
    "raven-edu-addon-loadout-bundle"
   ]
  }
 },
 "offers": [
  {
   "key": "raven-metal-finish-barrel",
   "title": "Metal Finish Barrel Upgrade",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/raven-metal-finish-barrel-chip.png?v=1790145136",
   "variantId": 46074576404659,
   "twinProductId": 8704625901747,
   "sourceProductId": 8704625868979,
   "sourceVariantId": 46074576371891,
   "wasCents": 795,
   "nowCents": 495,
   "saveCents": 300,
   "pct": 38,
   "blurb": "Metal-finish barrel for your Brick Raven.",
   "colls": [
    "pistol-accessories"
   ],
   "priority": 0.5,
   "attach": false,
   "fitTypes": null,
   "requireVariantIds": [
    45217056129203
   ]
  },
  {
   "key": "munitionspack-darts",
   "title": "Extra Darts + Casings",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/3F0805DA-817B-465B-AEF8-6015B50EF055.png?v=1768234570",
   "variantId": 45601046036659,
   "twinProductId": 8531051511987,
   "sourceProductId": 8403024216243,
   "sourceVariantId": 45217057013939,
   "wasCents": 1999,
   "nowCents": 1395,
   "saveCents": 604,
   "pct": 30,
   "blurb": "Works with all models that use darts + casings.",
   "colls": [
    "pistol-accessories",
    "pulse-shellblaster-accessories-copy",
    "shell-longgun-accessories",
    "shell-revolver",
    "smg",
    "venom-pro-accessories"
   ],
   "priority": 1,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8705476067507,
    8759944413363,
    8759944806579,
    8763269480627,
    8766964924595,
    8767031541939,
    8767791825075,
    8767791923379,
    8769951826099,
    8770003566771
   ]
  },
  {
   "key": "raven-edu-addon-3in1-attachment-bundle",
   "title": "3-in-1 Attachment Bundle",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/raven-edu-addon-3in1-v7-20260904_a527f358-c586-4850-ba4e-52396583aeab.jpg?v=1788548722",
   "variantId": 45958701318323,
   "twinProductId": 8650902536371,
   "sourceProductId": 8648849785011,
   "sourceVariantId": 45956378525875,
   "wasCents": 4000,
   "nowCents": 3499,
   "saveCents": 501,
   "pct": 13,
   "blurb": "\u2713 Red dot sight \u00b7 \u2713 Laser \u00b7 \u2713 Flashlight \u2014 all three clip right on the Raven rail you just bought",
   "colls": [
    "raven-edu-addons"
   ],
   "priority": 1,
   "attach": true,
   "fitTypes": null,
   "noFit": true,
   "coveredBy": [
    8705476067507,
    8767791857843
   ]
  },
  {
   "key": "extra-munition-hulsen",
   "title": "Extra Toy Casings",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/ChatGPTImage25.Apr.2025_22_08_08.png?v=1768234563",
   "variantId": 45601046429875,
   "twinProductId": 8531054952627,
   "sourceProductId": 8403023986867,
   "sourceVariantId": 45217056522419,
   "wasCents": 1299,
   "nowCents": 995,
   "saveCents": 304,
   "pct": 23,
   "blurb": "Extra casings \u2014 never run out mid-battle.",
   "colls": [
    "bigblaster-accessories-copy"
   ],
   "priority": 2,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8766967939251
   ]
  },
  {
   "key": "raven-edu-addon-mega-dart-pack",
   "title": "MEGA Dart + Casing Pack",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/50_casings_4087689c-c060-4d2f-9c6d-04e09c63f99f.png?v=1788548730",
   "variantId": 45958701351091,
   "twinProductId": 8650902569139,
   "sourceProductId": 8648861188275,
   "sourceVariantId": 45956390846643,
   "wasCents": 5000,
   "nowCents": 4499,
   "saveCents": 501,
   "pct": 10,
   "blurb": "\u2713 1000 soft plastic darts \u00b7 \u2713 50 casings \u2014 fits the Raven, never run dry",
   "colls": [
    "raven-edu-addons"
   ],
   "priority": 2,
   "attach": false,
   "fitTypes": null,
   "noFit": true
  },
  {
   "key": "extra-munition-revolver",
   "title": "Extra Darts + Casings for Venom",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/ChatGPTImage9.Dez.2025_22_02_31.png?v=1768234549",
   "variantId": 45601748091059,
   "twinProductId": 8531373883571,
   "sourceProductId": 8403023659187,
   "sourceVariantId": 45217055670451,
   "wasCents": 899,
   "nowCents": 695,
   "saveCents": 204,
   "pct": 23,
   "blurb": "Extra rounds for your revolver \u2014 never run dry.",
   "colls": [
    "pistol-accessories-copy-1"
   ],
   "priority": 3,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8766965317811
   ]
  },
  {
   "key": "raven-edu-addon-loadout-bundle",
   "title": "Loadout Bundle",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/raven-edu-addon-loadout-v6-20260904_6e028aa3-cd3a-41dd-a3ab-1c424c3d3162.jpg?v=1788548742",
   "variantId": 45958701383859,
   "twinProductId": 8650902601907,
   "sourceProductId": 8648869675187,
   "sourceVariantId": 45956400349363,
   "wasCents": 2999,
   "nowCents": 2499,
   "saveCents": 500,
   "pct": 17,
   "blurb": "\u2713 Extra magazine \u00b7 \u2713 Leather holster \u00b7 \u2713 3 practice targets \u2014 the full training loadout",
   "colls": [
    "raven-edu-addons"
   ],
   "priority": 3,
   "attach": false,
   "fitTypes": null,
   "noFit": true
  },
  {
   "key": "ammo-pack-shotgun",
   "title": "Extra Dart Pack for Pump-Action",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/ChatGPTImageJun26_2025_02_05_37PM.png?v=1768234543",
   "variantId": 45601748517043,
   "twinProductId": 8531374112947,
   "sourceProductId": 8403023429811,
   "sourceVariantId": 45217055211699,
   "wasCents": 1999,
   "nowCents": 1495,
   "saveCents": 504,
   "pct": 25,
   "blurb": "Extra shells \u2014 keep blasting without reloading.",
   "colls": [
    "pistol-accessories-copy-2"
   ],
   "priority": 4,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8766966104243
   ]
  },
  {
   "key": "extra-munition-2",
   "title": "Extra Foam Darts + Casings",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/2_bb593424-550e-4e9b-bc74-5d97c40be2d2.png?v=1768234544",
   "variantId": 45601748975795,
   "twinProductId": 8531374375091,
   "sourceProductId": 8403023560883,
   "sourceVariantId": 45217055506611,
   "wasCents": 1799,
   "nowCents": 1295,
   "saveCents": 504,
   "pct": 28,
   "blurb": "Extra foam darts + casings \u2014 stock up before battle.",
   "colls": [
    "pistol-accessories-copy-3",
    "pistol-accessories-copy-4"
   ],
   "priority": 5,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8766965645491
   ]
  },
  {
   "key": "inferno-minigun-ammo",
   "title": "Inferno Minigun Ammo Pack",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/hf_20260626_204339_b4ac4574-3f97-4b5c-87ab-ca8a4e53a6ef.png?v=1782507116",
   "variantId": 45601799078067,
   "twinProductId": 8531398754483,
   "sourceProductId": 8531396264115,
   "sourceVariantId": 45601794097331,
   "wasCents": 2299,
   "nowCents": 1595,
   "saveCents": 704,
   "pct": 31,
   "blurb": "A massive ammo pack to feed your minigun.",
   "colls": [
    "inferno-accessories"
   ],
   "priority": 6,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8766968135859
   ]
  },
  {
   "key": "blaster-ballons",
   "title": "111 Self-Sealing Water Balloons",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/hf_20260422_074054_0da1c39b-52ee-4bad-87ab-8e693f251562.png?v=1776843826",
   "variantId": 45602108342451,
   "twinProductId": 8531553714355,
   "sourceProductId": 8483663806643,
   "sourceVariantId": 45458846974131,
   "wasCents": 1900,
   "nowCents": 1395,
   "saveCents": 505,
   "pct": 27,
   "blurb": "111 self-sealing water balloons \u2014 instant ammo.",
   "colls": [
    "pistol-accessories-copy-5",
    "water-accessories-drum"
   ],
   "priority": 7,
   "attach": false,
   "fitTypes": null
  },
  {
   "key": "radish-disposable-shell-1911-toy-gun",
   "title": "Extra Darts + Casings for Bigblaster",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/ChatGPTImage25.Apr.2025_21_57_41.png?v=1768234564",
   "variantId": 45605041012915,
   "twinProductId": 8533041479859,
   "sourceProductId": 8403024052403,
   "sourceVariantId": 45217056653491,
   "wasCents": 1299,
   "nowCents": 995,
   "saveCents": 304,
   "pct": 23,
   "blurb": "Extra darts + casings for your Bigblaster \u2014 never run dry.",
   "colls": [
    "pistol-accessories-copy"
   ],
   "priority": 8,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8766966431923
   ]
  },
  {
   "key": "extra-shells-darts-outlaw-1873",
   "title": "Extra Shells + Darts \u2014 Outlaw 1873",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/outlaw-1873-ammo-v2-nano-banana-pro-transparent.png?v=1784657809",
   "variantId": 45697673068723,
   "twinProductId": 8560028483763,
   "sourceProductId": 8559512420531,
   "sourceVariantId": 45696585400499,
   "wasCents": 1299,
   "nowCents": 995,
   "saveCents": 304,
   "pct": 23,
   "blurb": "Extra ejecting shells + soft darts for your Outlaw 1873 \u2014 never run dry.",
   "colls": [
    "outlaw-1873-add-ons"
   ],
   "priority": 9,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8759945199795
   ]
  },
  {
   "key": "ersatzmagazin",
   "title": "Extra Replacement Clip",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/MB_22.png?v=1768234559",
   "variantId": 45601046069427,
   "twinProductId": 8531051806899,
   "sourceProductId": 8403023921331,
   "sourceVariantId": 45217056358579,
   "wasCents": 1499,
   "nowCents": 1195,
   "saveCents": 304,
   "pct": 20,
   "blurb": "Speed-load \u2014 swap mags instantly and keep firing.",
   "colls": [
    "accessories",
    "bigblaster-accessories-copy",
    "pistol-accessories",
    "pistol-accessories-copy",
    "pistol-accessories-copy-3",
    "pistol-accessories-copy-4",
    "pulse-shellblaster-accessories-copy",
    "shell-longgun-accessories",
    "smg"
   ],
   "priority": 10,
   "attach": true,
   "fitTypes": null,
   "coveredBy": [
    8705476067507,
    8759944413363,
    8759944806579,
    8763269480627,
    8766965645491,
    8766966431923,
    8766967939251,
    8767791825075,
    8769951826099,
    8770003566771
   ]
  },
  {
   "key": "extra-drum-magazine",
   "title": "Extra Drum Magazine",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/3d9723ed-ce05-4902-ab5f-ff657bb4f86c.png?v=1776644261",
   "variantId": 45602107130035,
   "twinProductId": 8531552960691,
   "sourceProductId": 8481147650227,
   "sourceVariantId": 45451299717299,
   "wasCents": 1499,
   "nowCents": 1095,
   "saveCents": 404,
   "pct": 27,
   "blurb": "High-capacity drum \u2014 way more shots per load.",
   "colls": [
    "water-accessories-drum"
   ],
   "priority": 11,
   "attach": true,
   "fitTypes": null
  },
  {
   "key": "tactical-light-red-laser-combo",
   "title": "Light + Laser Combo",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/MB_2_4d9442ee-89c5-4c27-9a25-c76f5af47ab0.png?v=1774529766",
   "variantId": 45601046200499,
   "twinProductId": 8531052888243,
   "sourceProductId": 8463079211187,
   "sourceVariantId": 45385627369651,
   "wasCents": 2999,
   "nowCents": 2195,
   "saveCents": 804,
   "pct": 27,
   "blurb": "Light + laser in one \u2014 dominate day or night.",
   "colls": [
    "accessories",
    "pistol-accessories",
    "pistol-accessories-copy",
    "pistol-accessories-copy-3",
    "pistol-accessories-copy-4",
    "shell-longgun-accessories",
    "smg",
    "venom-pro-accessories"
   ],
   "priority": 12,
   "attach": true,
   "fitTypes": null,
   "coveredBy": [
    8705476067507,
    8648849785011,
    8767791857843
   ]
  },
  {
   "key": "light-attatchment",
   "title": "Laser Attachment",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/MB_4.png?v=1768234536",
   "variantId": 45601046167731,
   "twinProductId": 8531052626099,
   "sourceProductId": 8403023200435,
   "sourceVariantId": 45217054556339,
   "wasCents": 1795,
   "nowCents": 1095,
   "saveCents": 700,
   "pct": 39,
   "blurb": "Real laser precision \u2014 aim faster, never miss.",
   "colls": [
    "accessories",
    "pistol-accessories",
    "pistol-accessories-copy",
    "pistol-accessories-copy-3",
    "pistol-accessories-copy-4",
    "shell-longgun-accessories",
    "smg",
    "venom-pro-accessories"
   ],
   "priority": 13,
   "attach": true,
   "fitTypes": null,
   "coveredBy": [
    8705476067507,
    8766967152819,
    8766967578803,
    8648849785011,
    8767791857843,
    8766966431923
   ]
  },
  {
   "key": "toy-targeting-scope",
   "title": "Red Dot Sight",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/ChatGPTImage6.Juni2025_16_30_34.png?v=1768234533",
   "variantId": 45601046233267,
   "twinProductId": 8531053150387,
   "sourceProductId": 8403023069363,
   "sourceVariantId": 45217054359731,
   "wasCents": 1495,
   "nowCents": 1195,
   "saveCents": 300,
   "pct": 20,
   "blurb": "Quick-mount red dot \u2014 lock on instantly.",
   "colls": [
    "accessories",
    "pistol-accessories",
    "pistol-accessories-copy",
    "pistol-accessories-copy-3",
    "pistol-accessories-copy-4",
    "shell-longgun-accessories",
    "venom-pro-accessories"
   ],
   "priority": 14,
   "attach": true,
   "fitTypes": null,
   "coveredBy": [
    8705476067507,
    8648849785011,
    8767791857843
   ]
  },
  {
   "key": "flashlight",
   "title": "Flashlight Attachment",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/MB_3_5a20697f-f11a-4e23-8ea7-184650f17932.png?v=1768234533",
   "variantId": 45601046266035,
   "twinProductId": 8531053412531,
   "sourceProductId": 8403023134899,
   "sourceVariantId": 45217054425267,
   "wasCents": 1495,
   "nowCents": 1095,
   "saveCents": 400,
   "pct": 27,
   "blurb": "Tactical flashlight \u2014 light up every target.",
   "colls": [
    "accessories",
    "pistol-accessories",
    "pistol-accessories-copy",
    "pistol-accessories-copy-3",
    "pistol-accessories-copy-4",
    "shell-longgun-accessories",
    "smg",
    "venom-pro-accessories"
   ],
   "priority": 15,
   "attach": true,
   "fitTypes": null,
   "coveredBy": [
    8705476067507,
    8648849785011,
    8767791857843
   ]
  },
  {
   "key": "rail-mount",
   "title": "Rail Mount",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/MB_ef95c7a7-e586-4c48-8c6c-7399165b25c6.png?v=1770469173",
   "variantId": 45601046397107,
   "twinProductId": 8531054624947,
   "sourceProductId": 8416279429299,
   "sourceVariantId": 45263637446835,
   "wasCents": 999,
   "nowCents": 695,
   "saveCents": 304,
   "pct": 30,
   "blurb": "Add a rail \u2014 mount more gear, build your loadout.",
   "colls": [
    "accessories",
    "pistol-accessories",
    "pistol-accessories-copy",
    "venom-pro-accessories"
   ],
   "priority": 16,
   "attach": true,
   "fitTypes": null,
   "coveredBy": [
    8705476067507,
    8648849785011,
    8767791857843
   ]
  },
  {
   "key": "western-thigh-holster",
   "title": "Western Thigh Holster",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/01-western-thigh-holster-transparent.png?v=1784612568",
   "variantId": 45706047324339,
   "twinProductId": 8563761119411,
   "sourceProductId": 8563755909299,
   "sourceVariantId": 45705996468403,
   "wasCents": 1999,
   "nowCents": 1395,
   "saveCents": 604,
   "pct": 30,
   "blurb": "Western-style carry for compatible toy revolvers.",
   "colls": [
    "accessories",
    "outlaw-1873-add-ons",
    "pistol-accessories-copy-1",
    "shell-revolver",
    "venom-pro-accessories"
   ],
   "priority": 20,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8759945199795,
    8766964924595,
    8766965317811,
    8767031541939,
    8767791956147
   ]
  },
  {
   "key": "gun-holster",
   "title": "Leather Blaster Holster",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/hf_20260625_154543_11a02712-f671-48ee-ab84-20746ee579d0.png?v=1782403263",
   "variantId": 45601046134963,
   "twinProductId": 8531052363955,
   "sourceProductId": 8416277233843,
   "sourceVariantId": 45278209409203,
   "wasCents": 1900,
   "nowCents": 1395,
   "saveCents": 505,
   "pct": 27,
   "blurb": "Carry it like the pros \u2014 premium leather holster.",
   "colls": [
    "accessories",
    "bigblaster-accessories-copy",
    "outlaw-1873-add-ons",
    "pistol-accessories",
    "pistol-accessories-copy",
    "pistol-accessories-copy-1",
    "shell-revolver",
    "venom-pro-accessories"
   ],
   "priority": 21,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8766967939251,
    8767791890611,
    8705476067507,
    8763269480627
   ]
  },
  {
   "key": "safety-glasses",
   "title": "Goggle",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/ChatGPTImage26.Apr.2025_17_54_42.png?v=1768234544",
   "variantId": 45601046364339,
   "twinProductId": 8531054428339,
   "sourceProductId": 8403023495347,
   "sourceVariantId": 45217055408307,
   "wasCents": 999,
   "nowCents": 695,
   "saveCents": 304,
   "pct": 30,
   "blurb": "Protect those eyes \u2014 battle-ready safety goggles.",
   "colls": [
    "accessories",
    "cyclone-add-ons",
    "outlaw-1873-add-ons",
    "pistol-accessories",
    "pistol-accessories-copy",
    "pistol-accessories-copy-1",
    "pistol-accessories-copy-2",
    "pistol-accessories-copy-3",
    "pistol-accessories-copy-4",
    "pulse-shellblaster-accessories-copy",
    "shell-longgun-accessories",
    "shell-revolver",
    "smg",
    "venom-pro-accessories"
   ],
   "priority": 23,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8763269480627,
    8759945199795,
    8766964924595,
    8766965317811,
    8766965645491,
    8766966104243,
    8766966431923,
    8766966825139,
    8766967152819,
    8766967578803,
    8766967939251,
    8766968135859,
    8767031541939,
    8767791890611,
    8767791956147,
    8769951826099,
    8770003566771
   ]
  },
  {
   "key": "sheriff-star-badge-outlaw-addon",
   "title": "Sheriff Star Badge",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/sheriff-star-badge-hero.png?v=1785696250",
   "variantId": 45767482081459,
   "twinProductId": 8584104870067,
   "sourceProductId": 8579567550643,
   "sourceVariantId": 45756233384115,
   "wasCents": 895,
   "nowCents": 695,
   "saveCents": 200,
   "pct": 22,
   "blurb": "Pin on the antique-gold star \u2014 complete your Old West loadout.",
   "colls": [
    "outlaw-1873-add-ons"
   ],
   "priority": 23,
   "attach": false,
   "fitTypes": null
  },
  {
   "key": "anti-fog-googles",
   "title": "Swim Goggles +Free Ear Plugs & Nose Clip",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/DesignohneTitel_39.png?v=1777697853",
   "variantId": 45602107916467,
   "twinProductId": 8531553484979,
   "sourceProductId": 8492061327539,
   "sourceVariantId": 45484117164211,
   "wasCents": 1500,
   "nowCents": 1195,
   "saveCents": 305,
   "pct": 20,
   "blurb": "Anti-fog goggles + ear plugs \u2014 splash-ready.",
   "colls": [
    "pistol-accessories-copy-5",
    "water-accessories-drum"
   ],
   "priority": 24,
   "attach": false,
   "fitTypes": null
  },
  {
   "key": "targets",
   "title": "Targets",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/ChatGPTImage12.Juni2025_12_47_02.png?v=1768234529",
   "variantId": 45601046102195,
   "twinProductId": 8531052134579,
   "sourceProductId": 8403022938291,
   "sourceVariantId": 45217054228659,
   "wasCents": 695,
   "nowCents": 595,
   "saveCents": 100,
   "pct": 14,
   "blurb": "Fun indoor & outdoor target practice.",
   "colls": [
    "accessories",
    "cyclone-add-ons",
    "outlaw-1873-add-ons",
    "pistol-accessories",
    "pistol-accessories-copy",
    "pistol-accessories-copy-1",
    "pistol-accessories-copy-2",
    "pistol-accessories-copy-3",
    "pistol-accessories-copy-4",
    "pistol-accessories-copy-5",
    "pulse-shellblaster-accessories-copy",
    "shell-longgun-accessories",
    "shell-revolver",
    "smg",
    "venom-pro-accessories",
    "water-accessories-drum"
   ],
   "priority": 25,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8705476067507,
    8759944413363,
    8759944806579,
    8759945199795,
    8763269480627,
    8766964924595,
    8766965317811,
    8766965645491,
    8766966104243,
    8766966431923,
    8766966825139,
    8766967152819,
    8766967578803,
    8766967939251,
    8766968135859,
    8767031541939,
    8767791825075,
    8767791923379,
    8769951826099,
    8770003566771
   ]
  },
  {
   "key": "schaumstoff-dartziele",
   "title": "Foam Targets",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/FREE_7.png?v=1768234543",
   "variantId": 45601046298803,
   "twinProductId": 8531053674675,
   "sourceProductId": 8403023528115,
   "sourceVariantId": 45217055441075,
   "wasCents": 1195,
   "nowCents": 895,
   "saveCents": 300,
   "pct": 25,
   "blurb": "Soft foam targets \u2014 safe practice anywhere.",
   "colls": [
    "accessories",
    "cyclone-add-ons",
    "inferno-accessories",
    "outlaw-1873-add-ons",
    "pistol-accessories",
    "pistol-accessories-copy",
    "pistol-accessories-copy-1",
    "pistol-accessories-copy-2",
    "pistol-accessories-copy-3",
    "pistol-accessories-copy-4",
    "pistol-accessories-copy-5",
    "pulse-shellblaster-accessories-copy",
    "shell-longgun-accessories",
    "shell-revolver",
    "smg",
    "venom-pro-accessories",
    "water-accessories-drum"
   ],
   "priority": 26,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8767031541939
   ]
  },
  {
   "key": "display-stand",
   "title": "Display Stand",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/Untitled_design_-_2026-03-13T195524.722.png?v=1773512752",
   "variantId": 45601046331571,
   "twinProductId": 8531054035123,
   "sourceProductId": 8403022348467,
   "sourceVariantId": 45217053147315,
   "wasCents": 999,
   "nowCents": 695,
   "saveCents": 304,
   "pct": 30,
   "blurb": "Show off your blaster on a clean display stand.",
   "colls": [
    "accessories",
    "bigblaster-accessories-copy",
    "outlaw-1873-add-ons",
    "pistol-accessories",
    "pistol-accessories-copy",
    "pistol-accessories-copy-1",
    "venom-pro-accessories"
   ],
   "priority": 27,
   "attach": false,
   "fitTypes": null
  },
  {
   "key": "miniblaster-tactical-battle-vest-1",
   "title": "Blaster Tactical Battle Vest",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/Untitleddesign-2026-03-13T194800.687.png?v=1773512573",
   "variantId": 45601799372979,
   "twinProductId": 8531398918323,
   "sourceProductId": 8403022282931,
   "sourceVariantId": 45217053081779,
   "wasCents": 1995,
   "nowCents": 1495,
   "saveCents": 500,
   "pct": 25,
   "blurb": "Gear up like a pro \u2014 tactical battle vest.",
   "colls": [
    "accessories",
    "inferno-accessories"
   ],
   "priority": 28,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8766968135859
   ]
  },
  {
   "key": "extra-battery",
   "title": "Extra Battery",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/8D711CEA-F796-47E2-8D05-49A38EE87C3A.png?v=1777033968",
   "variantId": 45602107588787,
   "twinProductId": 8531553222835,
   "sourceProductId": 8483655221427,
   "sourceVariantId": 45458800214195,
   "wasCents": 1499,
   "nowCents": 1095,
   "saveCents": 404,
   "pct": 27,
   "blurb": "Extra battery \u2014 keep the action going all day.",
   "colls": [
    "pistol-accessories-copy-5",
    "water-accessories-drum"
   ],
   "priority": 29,
   "attach": false,
   "fitTypes": null
  },
  {
   "key": "lebenslange-garantie-\u2705",
   "title": "Lifetime Warranty",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/DesignohneTitel_17.png?v=1773917316",
   "variantId": 45601799667891,
   "twinProductId": 8531399114931,
   "sourceProductId": 8403024085171,
   "sourceVariantId": 45217056686259,
   "wasCents": 799,
   "nowCents": 595,
   "saveCents": 204,
   "pct": 26,
   "blurb": "Lifetime warranty \u2014 buy once, covered forever.",
   "colls": [
    "accessories",
    "inferno-accessories",
    "pistol-accessories-copy-5",
    "water-accessories-drum"
   ],
   "priority": 30,
   "attach": false,
   "fitTypes": null
  },
  {
   "key": "cyclone-extra-cylinder",
   "title": "Cyclone Extra Cylinder",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/cyclone-extra-cylinder-black-teal.webp?v=1784227129",
   "variantId": 45785385566387,
   "twinProductId": 8589992591539,
   "sourceProductId": 8558388445363,
   "sourceVariantId": 45693902028979,
   "wasCents": 999,
   "nowCents": 795,
   "saveCents": 204,
   "pct": 20,
   "blurb": "Swap-in second cylinder \u2014 reload in one click.",
   "colls": [
    "accessories",
    "cyclone-add-ons"
   ],
   "priority": 50,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8766966825139
   ]
  },
  {
   "key": "cyclone-extra-ammo",
   "title": "Cyclone Extra Ammo \u2014 10 Suction-Cup Darts",
   "image": "https://cdn.shopify.com/s/files/1/0742/0769/0931/files/cyclone-extra-ammo-transparent.png?v=1784227134",
   "variantId": 45785385599155,
   "twinProductId": 8589992624307,
   "sourceProductId": 8559352971443,
   "sourceVariantId": 45696316670131,
   "wasCents": 795,
   "nowCents": 595,
   "saveCents": 200,
   "pct": 25,
   "blurb": "Extra suction-cup darts for your Cyclone \u2014 never run dry.",
   "colls": [
    "accessories",
    "cyclone-add-ons"
   ],
   "priority": 50,
   "attach": false,
   "fitTypes": null,
   "coveredBy": [
    8766966825139
   ]
  }
 ],
 "timerMinutes": 10,
 "showOncePerSession": false,
 "cartSectionId": "cart-drawer",
 "maxVisible": 12
};
